// extracted by mini-css-extract-plugin
export default {"checkout_summary":"ro","checkout_summary_wrapper":"so","summary_items":"to","line_items_wrapper":"uo","separator":"vo","order_summary":"wo","line_item":"xo","order__summary_item_title":"yo","recurringdis":"zo","note":"Ao","carbon_emission":"Bo","unlock_savings":"Co","member_perk":"Eo","info":"Fo","no_items":"Go","promo":"Ho","order_summary_mobile":"Io","open_summary_mobile":"Jo","fixed_bottom_info":"Ko","open_info":"Lo","text":"Mo","open_summary":"No"};
    if(module.hot) {
      // 1713809675451
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  